import { connect } from 'react-redux'
import { memoize } from 'lodash'
import { createAuthStateToProps } from 'helpers/auth'
import { createChildItemsDispatchToProps } from 'helpers/formViews'
import rfqActions from 'actions/rfqs'
import supplierActions from 'actions/suppliers'
import rfqItemActions from 'actions/rfqs/rfqItems'
import rfqSupplierActions from 'actions/rfqs/rfqSuppliers'
import documentActions from 'actions/documents'
import requisitionActions from 'actions/requisitions'
import Component from 'components/Requisitions/Items/ConvertToRfq'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = (dispatch, props) => ({
  getSupplier: memoize((supplierId) => dispatch(supplierActions.getItem(supplierId))),
  closeRequisition: (params) => dispatch(requisitionActions.closeRequisition(params)),
  newRfq: (params) => dispatch(rfqActions.newItem(params)),
  saveRfq: (params) => dispatch(rfqActions.saveRfq(params)),
  populateRfqItems: (params) => dispatch(rfqItemActions.populateRfqItems(params)),
  copyAllObjectDocuments: (params) => dispatch(documentActions.copyAllObjectDocuments(params)),
  ...createChildItemsDispatchToProps(dispatch, 'Rfq', rfqItemActions),
  ...createChildItemsDispatchToProps(dispatch, 'RfqSupplier', rfqSupplierActions),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
